module.exports = __webpack_public_path__ + "img/2.0a9650a7.0a9650a7.gif";